import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import { CommonService } from "app/reusable/common.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-delete-icd-diagnose',
  templateUrl: './delete-icd-diagnose.component.html',
  styleUrls: ['./delete-icd-diagnose.component.scss']
})
export class DeleteIcdDiagnoseComponent implements OnInit, OnDestroy {

  public DeleteDialogOpened = false;
  @Input() icdDiagnose: any;
  @Output() Change = new EventEmitter();
  private _subject$: Subject<boolean> = new Subject();

  constructor(private CommonService: CommonService) { }

  ngOnInit() { }

  public Delete() {
    if(this.icdDiagnose.icdId!= null){
      let deleteUrl: string = `IcdDiagnose/Delete/${this.icdDiagnose.icdId}`;
      this.CommonService.delete(deleteUrl).pipe(takeUntil(this._subject$)).subscribe(
        (res) => {        
          this.Change.emit({ icdDiagnose: this.icdDiagnose, dialogstatus: false });
        },
        (error) => {
          this.Change.emit({ icdDiagnose: null, dialogstatus: false });
        });
    }
    else{
      this.Change.emit({ icdDiagnose: this.icdDiagnose, dialogstatus: false });
    }
  }

  public Cancel() {
    this.Change.emit({ icdDiagnose: null, dialogstatus: false });
  }

  ngOnDestroy() {
    this._subject$.unsubscribe();
  }
}
